import React, { useState, useEffect } from 'react';
import { Row, Col, Collapse, Label, Input, Button, Card, CardBody, Spinner, CardHeader, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Select, { components } from 'react-select';
import { FaChevronRight, FaChevronLeft, FaChevronUp, FaChevronDown, FaUpload } from 'react-icons/fa';
import toast, { Toaster } from 'react-hot-toast';
import SpinnerContainer from '../Utilities/Ui/SpinnerContainer';
import axios from 'axios';
import uuid from 'react-uuid';
import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer, toast as toastytoast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "draft-js/dist/Draft.css";import { apiGet,apiPost } from "../Utilities/Hooks/apiWrapper";

const ContaminantEvaluation = ({ handleWizardChanged, handleWizardChangedBack, handleMoveToNextPage }) => {
    const roleName = localStorage.getItem("roleName"); const [isNextButtonVisible, setIsNextButtonVisible] = useState(false);
    const isAddEditItem = localStorage.getItem("isAddEditItem");
    const saveRightsForNonItemFieldsAndTables = localStorage.getItem("saveRightsForNonItemFieldsAndTables");
    const [loading, setLoading] = useState(true);
    const [farmId, setFarmId] = useState(localStorage.getItem("defaultFarmId"));
    const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId"));
    const [contaminantEvaluation, setContaminantEvaluation] = useState({
        Section: 'Contaminant Self Evaluation', SectionName: 'Contaminant - Self-evaluation', isWizardCompleted: false,
        nitrogen: 'Low', pathogen: 'Low', phosphorous: 'Low', erosion:'Low'
    });
    const [erosionRows, setErosionRows] = useState([]);
    const [nitrogenRows, setNitrogenRows] = useState([]);
    const [phosphorousRows, setPhosphorousRows] = useState([]);
    const [pathogenRows, setPathogenRows] = useState([]);
    useEffect(() => {
        setLoading(true);
        populateItemData();
    }, []);

    const Option = (props) => {
        return (
            <div>
                <components.Option {...props}>
                    <input
                        type="checkbox"
                        checked={props.isSelected}
                        onChange={() => null}
                    />{" "}
                    <label>{props.label}</label>
                </components.Option>
            </div>
        );
    };
    const populateItemData = async () => {
        try {
            const response = await apiGet(
                '/api/ContaminantEvaluation/GetContaminantEvaluationDetails/', {
                params: { Id: farmId }
            }
            );
            setContaminantEvaluation({ ...contaminantEvaluation, erosion: response.data.content.erosion, pathogen: response.data.content.pathogen, phosphorous: response.data.content.phosphorous, nitrogen: response.data.content.nitrogen });
            setErosionRows(response.data.content.contaminantSelfEvaluationDetailList.filter(x => x.type == "Erosion"));
            setNitrogenRows(response.data.content.contaminantSelfEvaluationDetailList.filter(x => x.type == "Nitrogen"));
            setPhosphorousRows(response.data.content.contaminantSelfEvaluationDetailList.filter(x => x.type == "Phosphorous"));
            setPathogenRows(response.data.content.contaminantSelfEvaluationDetailList.filter(x => x.type == "Pathogen"));
            setLoading(false);
        }
        catch (err) {
            if (!err?.response) {

            } else if (err.response?.status === 400) {

            } else {

            }
            setLoading(false);
        }
    }
    const [isErosionOpen, setIsErosionOpen] = useState(true);
    const [isErosionIconUp, setIsErosionIconUp] = useState(false);
    const toggleErosion = () => {
        setIsErosionOpen(!isErosionOpen);
        setIsErosionIconUp(!isErosionIconUp);
    };

    const [isNitrogenOpen, setIsNitrogenOpen] = useState(true);
    const [isNitrogenIconUp, setIsNitrogenIconUp] = useState(false);
    const toggleNitrogen = () => {
        setIsNitrogenOpen(!isNitrogenOpen);
        setIsNitrogenIconUp(!isNitrogenIconUp);
    };

    const [isPhosphorusOpen, setIsPhosphorusOpen] = useState(true);
    const [isPhosphorusIconUp, setIsPhosphorusIconUp] = useState(false);
    const togglesPhosphorus = () => {
        setIsPhosphorusOpen(!isPhosphorusOpen);
        setIsPhosphorusIconUp(!isPhosphorusIconUp);
    };

    const [isPathogensOpen, setIsPathogensOpen] = useState(true);
    const [isPathogensIconUp, setIsPathogensIconUp] = useState(false);
    const togglePathogens = () => {
        setIsPathogensOpen(!isPathogensOpen);
        setIsPathogensIconUp(!isPathogensIconUp);
    };

    const handleErosionValueChange = (e,idx,srNo) => {
        const tempRows = [...erosionRows];
        tempRows[idx].value = e.target.value;
        const tempRow7 = srNo == 7 ? e.target.value : tempRows.filter(x => x.srNo == 7)[0].value;
        const tempRow8 = srNo == 8 ? e.target.value : tempRows.filter(x => x.srNo == 8)[0].value;
        const tempRow4 = srNo == 4 ? e.target.value : tempRows.filter(x => x.srNo == 4)[0].value;
        const tempRow5 = srNo == 5 ? e.target.value : tempRows.filter(x => x.srNo == 5)[0].value;
        const tempRow6 = srNo == 6 ? e.target.value : tempRows.filter(x => x.srNo == 6)[0].value;
        const tempRow3 = srNo == 3 ? e.target.value : tempRows.filter(x => x.srNo == 3)[0].value;
        const tempRow2 = srNo == 2 ? e.target.value : tempRows.filter(x => x.srNo == 2)[0].value;
        const tempRow1 = srNo == 1 ? e.target.value : tempRows.filter(x => x.srNo == 1)[0].value;
        if (tempRow7 == 'Yes' || tempRow8 == 'Yes') {
            setContaminantEvaluation({ ...contaminantEvaluation, erosion: 'High' });
        }
        else if (tempRow4 == 'Yes' || tempRow5 == 'Yes' || tempRow6 == 'Yes') {
            setContaminantEvaluation({ ...contaminantEvaluation, erosion: 'Medium' });
        }
        else if (tempRow3 == 'Yes' && tempRow2 == 'Yes' && tempRow1 == 'Yes') {
            setContaminantEvaluation({ ...contaminantEvaluation, erosion: 'Low' });
        }
        else {
            setContaminantEvaluation({ ...contaminantEvaluation, erosion: 'Low' });
        }
        setErosionRows(tempRows);
    };
    const handleNitrogenValueChange = (e, idx, srNo) => {
        const tempRows = [...nitrogenRows];
        tempRows[idx].value = e.target.value;
        const tempRow4 = srNo == 4 ? e.target.value : tempRows.filter(x => x.srNo == 4)[0].value;
        const tempRow3 = srNo == 3 ? e.target.value : tempRows.filter(x => x.srNo == 3)[0].value;
        const tempRow2 = srNo == 2 ? e.target.value : tempRows.filter(x => x.srNo == 2)[0].value;
        const tempRow1 = srNo == 1 ? e.target.value : tempRows.filter(x => x.srNo == 1)[0].value;
        var count = 0;
        if (tempRow4 == 'Yes') {
            ++count;
        }
        if (tempRow3 == 'Yes') {
            ++count;
        }
        if (tempRow2 == 'Yes') {
            ++count;
        }
        if (tempRow1 == 'Yes') {
            ++count;
        }
        if (count > 1)
        {
            setContaminantEvaluation({ ...contaminantEvaluation, nitrogen: 'High' });
        }
        else if (count == 1)
        {
            setContaminantEvaluation({ ...contaminantEvaluation, nitrogen: 'Medium' });
        }
        else {
            setContaminantEvaluation({ ...contaminantEvaluation, nitrogen: 'Low' });
        }
        setNitrogenRows(tempRows);
    };
    const handlePhosphorousValueChange = (e, idx, srNo) => {
        const tempRows = [...phosphorousRows];
        tempRows[idx].value = e.target.value;
        const tempRow6 = srNo == 6 ? e.target.value : tempRows.filter(x => x.srNo == 6)[0].value;
        const tempRow5 = srNo == 5 ? e.target.value : tempRows.filter(x => x.srNo == 5)[0].value;
        const tempRow4 = srNo == 4 ? e.target.value : tempRows.filter(x => x.srNo == 4)[0].value;
        const tempRow3 = srNo == 3 ? e.target.value : tempRows.filter(x => x.srNo == 3)[0].value;
        const tempRow2 = srNo == 2 ? e.target.value : tempRows.filter(x => x.srNo == 2)[0].value;
        const tempRow1 = srNo == 1 ? e.target.value : tempRows.filter(x => x.srNo == 1)[0].value;
        var count = 0;
        if (tempRow6 == 'Yes') {
            ++count;
        }
        if (tempRow5 == 'Yes') {
            ++count;
        }
        if (tempRow4 == 'Yes') {
            ++count;
        }
        if (tempRow3 == 'Yes') {
            ++count;
        }
        if (tempRow2 == 'Yes') {
            ++count;
        }
        if (tempRow1 == 'Yes') {
            ++count;
        }
        if (count > 1) {
            setContaminantEvaluation({ ...contaminantEvaluation, phosphorous: 'High' });
        }
        else if (count == 1) {
            setContaminantEvaluation({ ...contaminantEvaluation, phosphorous: 'Medium' });
        }
        else {
            setContaminantEvaluation({ ...contaminantEvaluation, phosphorous: 'Low' });
        }
        setPhosphorousRows(tempRows);
    };
    const handlePathogenValueChange = (e, idx, srNo) => {
        const tempRows = [...pathogenRows];
        tempRows[idx].value = e.target.value;
        const tempRow3 = srNo == 3 ? e.target.value : tempRows.filter(x => x.srNo == 3)[0].value;
        const tempRow2 = srNo == 2 ? e.target.value : tempRows.filter(x => x.srNo == 2)[0].value;
        const tempRow1 = srNo == 1 ? e.target.value : tempRows.filter(x => x.srNo == 1)[0].value;
        if (tempRow2 == 'Yes' && tempRow3 == 'Yes') {
            setContaminantEvaluation({ ...contaminantEvaluation, pathogen: 'High' });
        }
        else if (tempRow2 == 'Yes' || tempRow3 == 'Yes') {
            setContaminantEvaluation({ ...contaminantEvaluation, pathogen: 'Medium' });
        }
        else if (tempRow1 == 'Yes') {
            setContaminantEvaluation({ ...contaminantEvaluation, pathogen: 'Low' });
        }
        else {
            setContaminantEvaluation({ ...contaminantEvaluation, pathogen: 'Low' });
        }
        setPathogenRows(tempRows);
    };

    const [showsavingErosion, setShowSavingErosion] = useState(true);
    const [showsavingNitrogen, setShowSavingNitrogen] = useState(true);
    const [showsavingPhosphorous, setShowSavingPhosphorous] = useState(true);
    const [showsavingPathogen, setShowSavingPathogen] = useState(true);

    const [savingErosion, setSavingErosion] = useState(false);
    const [savingNitrogen, setSavingNitrogen] = useState(false);
    const [savingPhosphorous, setSavingPhosphorous] = useState(false);
    const [savingPathogen, setSavingPathogen] = useState(false);
    const handleSavingErosion = async (e) => {
        e.preventDefault()
        setSavingErosion(true);
        setShowSavingNitrogen(false);
        setShowSavingPhosphorous(false);
        setShowSavingPathogen(false);
        saveContaminantEvaluation(e,'');
    };
    const handleSavingNitrogen = async (e) => {
        e.preventDefault()
        setSavingNitrogen(true);
        setShowSavingErosion(false);
        setShowSavingPhosphorous(false);
        setShowSavingPathogen(false);
        saveContaminantEvaluation(e, '');
    };
    const handleSavingPhosphorous = async (e) => {
        e.preventDefault()
        setSavingPhosphorous(true);
        setShowSavingErosion(false);
        setShowSavingNitrogen(false);
        setShowSavingPathogen(false);
        saveContaminantEvaluation(e, '');
    };
    const handleSavingPathogen = async (e) => {
        e.preventDefault()
        setSavingPathogen(true);
        setShowSavingErosion(false);
        setShowSavingNitrogen(false);
        setShowSavingPhosphorous(false);
        saveContaminantEvaluation(e, '');
    };

    const handleNextButton = async (e,section,type) => {
        e.preventDefault();
        await saveContaminantEvaluation(e,'Next');
        if (type == 'handleWizardChanged') {
            handleWizardChanged(section);
        }
        else if (type == 'handleMoveToNextPage') {
            handleMoveToNextPage(section);
        }
    };

    const saveContaminantEvaluation = async (e,type) => {
        var ContaminantSelfEvaluationHeaderModel = {
            FarmId: farmId,
            Erosion: contaminantEvaluation.erosion,
            Nitrogen: contaminantEvaluation.nitrogen,
            Phosphorous: contaminantEvaluation.phosphorous,
            Pathogen: contaminantEvaluation.pathogen,
        };
        var form = {
            UserId: userId,
            FarmId: farmId,
            ContaminantSelfEvaluationHeader: ContaminantSelfEvaluationHeaderModel,
            ContaminantSelfEvaluationDetailList: []
        };
        for (var i = 0; i < erosionRows.length; i++) {
            var obj = {};
            obj.Id = erosionRows[i].id;
            obj.FarmId = erosionRows[i].farmId;
            obj.SrNo = erosionRows[i].srNo;
            obj.Type = erosionRows[i].type;
            obj.Description = erosionRows[i].description;
            obj.Value = erosionRows[i].value;
            form.ContaminantSelfEvaluationDetailList.push(obj);
        }
        for (var i = 0; i < nitrogenRows.length; i++) {
            var obj = {};
            obj.Id = nitrogenRows[i].id;
            obj.FarmId = nitrogenRows[i].farmId;
            obj.SrNo = nitrogenRows[i].srNo;
            obj.Type = nitrogenRows[i].type;
            obj.Description = nitrogenRows[i].description;
            obj.Value = nitrogenRows[i].value;
            form.ContaminantSelfEvaluationDetailList.push(obj);
        }
        for (var i = 0; i < pathogenRows.length; i++) {
            var obj = {};
            obj.Id = pathogenRows[i].id;
            obj.FarmId = pathogenRows[i].farmId;
            obj.SrNo = pathogenRows[i].srNo;
            obj.Type = pathogenRows[i].type;
            obj.Description = pathogenRows[i].description;
            obj.Value = pathogenRows[i].value;
            form.ContaminantSelfEvaluationDetailList.push(obj);
        }
        for (var i = 0; i < phosphorousRows.length; i++) {
            var obj = {};
            obj.Id = phosphorousRows[i].id;
            obj.FarmId = phosphorousRows[i].farmId;
            obj.SrNo = phosphorousRows[i].srNo;
            obj.Type = phosphorousRows[i].type;
            obj.Description = phosphorousRows[i].description;
            obj.Value = phosphorousRows[i].value;
            form.ContaminantSelfEvaluationDetailList.push(obj);
        }
        const response = await apiPost(
            '/api/ContaminantEvaluation/Save/', JSON.stringify(form),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
        if (response.data != null) {
            if (response.data.status) {
                setContaminantEvaluation({ ...contaminantEvaluation, erosion: response.data.content.erosion, pathogen: response.data.content.pathogen, phosphorous: response.data.content.phosphorous, nitrogen: response.data.content.nitrogen });
                setErosionRows(response.data.content.contaminantSelfEvaluationDetailList.filter(x => x.type == "Erosion"));
                setNitrogenRows(response.data.content.contaminantSelfEvaluationDetailList.filter(x => x.type == "Nitrogen"));
                setPhosphorousRows(response.data.content.contaminantSelfEvaluationDetailList.filter(x => x.type == "Phosphorous"));
                setPathogenRows(response.data.content.contaminantSelfEvaluationDetailList.filter(x => x.type == "Pathogen"));
                toast.success("Details Saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                if (type != 'Next') {
                    setTimeout(() => {
                        setSavingErosion(false);
                        setSavingNitrogen(false);
                        setSavingPhosphorous(false);
                        setSavingPathogen(false);
                        setShowSavingErosion(true);
                        setShowSavingNitrogen(true);
                        setShowSavingPathogen(true);
                        setShowSavingPhosphorous(true);
                        //window.location.reload(true);
                    }, 2000);
                }
                
            }
        }
        else {
            setSavingErosion(false);
            setSavingNitrogen(false);
            setSavingPhosphorous(false);
            setSavingPathogen(false);
            setShowSavingErosion(true);
            setShowSavingNitrogen(true);
            setShowSavingPathogen(true);
            setShowSavingPhosphorous(true);
        }
    }

    return (
        <div>
            <ToastContainer position="top-center" containerStyle={{ top: '50%' }} />
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Row>
                <Col><h3 className="header3">{contaminantEvaluation.SectionName}</h3></Col>
                { !loading &&
                    <Col>
                        {(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                            <>
                            {erosionRows != undefined && erosionRows.length > 0 &&
                                erosionRows[0].value != '' && erosionRows[1].value != '' && erosionRows[2].value != '' && erosionRows[3].value != '' && erosionRows[4].value != '' && erosionRows[5].value != '' && erosionRows[6].value != '' && erosionRows[7].value != '' &&
                                erosionRows[0].value != null && erosionRows[1].value != null && erosionRows[2].value != null && erosionRows[3].value != null && erosionRows[4].value != null && erosionRows[5].value != null && erosionRows[6].value != null && erosionRows[7].value != null &&
                                nitrogenRows != undefined && nitrogenRows.length > 0 &&
                                nitrogenRows[0].value != '' && nitrogenRows[1].value != '' && nitrogenRows[2].value != '' && nitrogenRows[3].value != '' &&
                                nitrogenRows[0].value != null && nitrogenRows[1].value != null && nitrogenRows[2].value != null && nitrogenRows[3].value != null &&
                                phosphorousRows != undefined && phosphorousRows.length > 0 &&
                                phosphorousRows[0].value != '' && phosphorousRows[1].value != '' && phosphorousRows[2].value != '' && phosphorousRows[3].value != '' && phosphorousRows[4].value != '' && phosphorousRows[5].value != '' &&
                                phosphorousRows[0].value != null && phosphorousRows[1].value != null && phosphorousRows[2].value != null && phosphorousRows[3].value != null && phosphorousRows[4].value != null && phosphorousRows[5].value != null &&
                                pathogenRows != undefined && pathogenRows.length > 0 &&
                                pathogenRows[0].value != '' && pathogenRows[1].value != '' && pathogenRows[2].value != '' && 
                                pathogenRows[0].value != null && pathogenRows[1].value != null && pathogenRows[2].value != null && 
                                <Button className="float-end btn-next-page" onClick={(e) => handleNextButton(e, contaminantEvaluation.Section,'handleWizardChanged')}>Next <FaChevronRight /> </Button>
                                }
                            </>
                        }
                        {(roleName != 'Admin' && saveRightsForNonItemFieldsAndTables == 'false') && isNextButtonVisible &&
                            <>
                            {erosionRows != undefined && erosionRows.length > 0 &&
                                erosionRows[0].value != '' && erosionRows[1].value != '' && erosionRows[2].value != '' && erosionRows[3].value != '' && erosionRows[4].value != '' && erosionRows[5].value != '' && erosionRows[6].value != '' && erosionRows[7].value != '' &&
                                erosionRows[0].value != null && erosionRows[1].value != null && erosionRows[2].value != null && erosionRows[3].value != null && erosionRows[4].value != null && erosionRows[5].value != null && erosionRows[6].value != null && erosionRows[7].value != null &&
                                nitrogenRows != undefined && nitrogenRows.length > 0 &&
                                nitrogenRows[0].value != '' && nitrogenRows[1].value != '' && nitrogenRows[2].value != '' && nitrogenRows[3].value != '' &&
                                nitrogenRows[0].value != null && nitrogenRows[1].value != null && nitrogenRows[2].value != null && nitrogenRows[3].value != null &&
                                phosphorousRows != undefined && phosphorousRows.length > 0 &&
                                phosphorousRows[0].value != '' && phosphorousRows[1].value != '' && phosphorousRows[2].value != '' && phosphorousRows[3].value != '' && phosphorousRows[4].value != '' && phosphorousRows[5].value != '' &&
                                phosphorousRows[0].value != null && phosphorousRows[1].value != null && phosphorousRows[2].value != null && phosphorousRows[3].value != null && phosphorousRows[4].value != null && phosphorousRows[5].value != null &&
                                pathogenRows != undefined && pathogenRows.length > 0 &&
                                pathogenRows[0].value != '' && pathogenRows[1].value != '' && pathogenRows[2].value != '' &&
                                pathogenRows[0].value != null && pathogenRows[1].value != null && pathogenRows[2].value != null &&
                                <Button className="float-end btn-next-page" onClick={(e) => handleNextButton(e, contaminantEvaluation.Section,'handleMoveToNextPage')}>Next <FaChevronRight /> </Button>
                            }
                            </>
                        }
                                <Button className="float-end btn-next-page" onClick={(section) => handleWizardChangedBack(contaminantEvaluation.Section)}>Back <FaChevronLeft /> </Button>
                    </Col>
                }
            </Row>
            {loading ? <SpinnerContainer /> : <>
                <Row>
                    <Col>
                        <p><b>There are 4 contaminants of concern – Sediment, Nitrogen, Phosphorous, and e Coli.</b></p>
                        • Based on your risk rating for each of the 4 contaminants, you will be prompted with a reminder to add actions to items on the farm, or the farm itself, to help mitigate these contamination risks.
                        <br/>
                        • The tool will also present you with system-generated risks (based on your farm and farming activities) and you will be asked to rate these risks. Base your rating on the outcomes of these self-evaluation checklists.
                        <br />
                        • These action guides will help you show a previous history of ongoing actions already initiated and actions already completed. This tells an important story for your farm management and will show in the full Freshwater Farm Plan report.
                    </Col>
                </Row>
                <Row xs="2">
                    <Col>
                        <Card className="my-4 card-header-outline" style={{ minHeight: "35vw", maxHeight: "100vw" }}>
                            <CardHeader className="" onClick={toggleNitrogen}>
                                <Row>
                                    <Col sm="11">
                                        <h5>Nitrogen</h5>
                                    </Col>
                                    <Col sm="1" className="toggleoutline_lt">{isNitrogenIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                                </Row>
                            </CardHeader>
                            <br />
                            <Collapse isOpen={isNitrogenOpen}>
                                <CardBody>
                                    <Row>
                                        <Col>
                                            <table style={{ float: "right", marginTop: "-10px" }} className="table table-bordered table-hover" id="tab_logic">
                                                <thead>
                                                    <tr>
                                                        <th className="text-left"> </th>
                                                        <th className="text-left"> Nitrogen Contamination Risk to Freshwater  </th>
                                                        <th className="text-left"> Yes/No </th>
                                                    </tr>
                                                </thead>
                                                <tbody className="text-left">
                                                    {nitrogenRows != undefined &&
                                                        nitrogenRows.length > 0 &&
                                                        nitrogenRows.map((item, idx) => (
                                                            <tr id="addr0" key={idx}>
                                                                <td style={{ display: "none" }}>{nitrogenRows[idx].id}</td>
                                                                <td style={{ width: "10%" }}>
                                                                    {nitrogenRows[idx].srNo}
                                                                </td>
                                                                <td style={{ width: "80%" }}>
                                                                    {nitrogenRows[idx].description}
                                                                </td>
                                                                <td style={{ width: "10%" }}>
                                                                    <Input type="select" value={nitrogenRows[idx].value} onChange={(e) => handleNitrogenValueChange(e, idx, nitrogenRows[idx].srNo)} name="value" id="value">
                                                                        <option key={uuid()} value=''></option>
                                                                        <option key={uuid()} value='Yes'>Yes</option>
                                                                        <option key={uuid()} value='No'>No</option>
                                                                    </Input>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    <tr id="addr0" key="nitrogenResult" style={{ backgroundColor: "rgba(82, 175, 181, 0.18)" }}>
                                                        <td style={{ width: "90%" }} colSpan="2">
                                                            <b>Risk Evaluation Guide</b>
                                                            <br />
                                                            • If you answered yes to any of the above questions, then you have at least a medium risk of nitrogen contamination of freshwater.
                                                            <br />
                                                            • If you answered yes to more than one question, then you will likely have a high risk of nitrogen contamination of freshwater
                                                        </td>
                                                        <td style={{ width: "10%", textAlign: 'center' }}>
                                                            <b><span style={{ color: contaminantEvaluation.nitrogen == 'High' ? 'rgb(224, 0, 0)' : (contaminantEvaluation.nitrogen == 'Medium' ? 'rgb(255, 134, 3)' : (contaminantEvaluation.nitrogen == 'Low' ? 'rgb(0, 188, 18)' : '')) }}>{contaminantEvaluation.nitrogen}</span></b>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            {nitrogenRows != undefined && nitrogenRows.length > 0 && showsavingNitrogen &&
                                                nitrogenRows[0].value != '' && nitrogenRows[1].value != '' && nitrogenRows[2].value != '' && nitrogenRows[3].value != '' &&
                                                nitrogenRows[0].value != null && nitrogenRows[1].value != null && nitrogenRows[2].value != null && nitrogenRows[3].value != null &&
                                                (roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                                                <>
                                                    {savingNitrogen ?
                                                        <Button style={{ float: "right" }} onClick={handleSavingNitrogen}
                                                            color="success"
                                                            disabled
                                                        >
                                                            <Row>
                                                                <Col sm="8">
                                                                    <span>
                                                                        {' '}Saving
                                                                    </span>
                                                                </Col>
                                                                <Col sm="4">
                                                                    <Spinner size="sm">
                                                                        Saving...
                                                                    </Spinner>
                                                                </Col>
                                                            </Row>
                                                        </Button>
                                                        :
                                                        <Button style={{ float: "right" }} onClick={handleSavingNitrogen} color="success" size="sm">
                                                            Save
                                                        </Button>
                                                    }
                                                </>

                                            }
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Collapse>
                        </Card>
                    </Col>
                    <Col>
                        <Card className="my-4 card-header-outline" style={{minHeight:"35vw",maxHeight:"100vw"}}>
                            <CardHeader className="" onClick={togglePathogens}>
                                <Row>
                                    <Col sm="11">
                                        <h5>Pathogens (Ecoli)</h5>
                                    </Col>
                                    <Col sm="1" className="toggleoutline_lt">{isPathogensIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                                </Row>
                            </CardHeader>
                            <br />
                            <Collapse isOpen={isPathogensOpen}>
                                <CardBody>
                                    <Row>
                                        <Col>
                                            <table style={{ float: "right", marginTop: "-10px" }} className="table table-bordered table-hover" id="tab_logic">
                                                <thead>
                                                    <tr>
                                                        <th className="text-left"> </th>
                                                        <th className="text-left"> Faecal Bacteria Contamination Risk to freshwater  </th>
                                                        <th className="text-left"> Yes/No </th>
                                                    </tr>
                                                </thead>
                                                <tbody className="text-left">
                                                    {pathogenRows != undefined &&
                                                        pathogenRows.length > 0 &&
                                                        pathogenRows.map((item, idx) => (
                                                            <tr id="addr0" key={idx}>
                                                                <td style={{ display: "none" }}>{pathogenRows[idx].id}</td>
                                                                <td style={{ width: "10%" }}>
                                                                    {pathogenRows[idx].srNo}
                                                                </td>
                                                                <td style={{ width: "80%" }}>
                                                                    {pathogenRows[idx].description}
                                                                </td>
                                                                <td style={{ width: "10%" }}>
                                                                    <Input type="select" value={pathogenRows[idx].value} onChange={(e) => handlePathogenValueChange(e, idx, pathogenRows[idx].srNo)} name="value" id="value">
                                                                        <option key={uuid()} value=''></option>
                                                                        <option key={uuid()} value='Yes'>Yes</option>
                                                                        <option key={uuid()} value='No'>No</option>
                                                                    </Input>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    <tr id="addr0" key="pathogenResult" style={{ backgroundColor: "rgba(82, 175, 181, 0.18)" }}>
                                                        <td style={{ width: "90%" }} colSpan="2">
                                                            <b>Risk Evaluation Guide</b>
                                                            <br />
                                                            • If you answered Yes to question 1, you have at least a low risk of faecal contamination of freshwater.
                                                            <br />
                                                            • If you answered Yes to questions 2 or 3 then you have at least a medium risk of faecal contamination of freshwater.
                                                            <br />
                                                            • If you answered Yes to questions 2 and 3 then you will likely have a high risk of faecal contamination of freshwater
                                                        </td>
                                                        <td style={{ width: "10%", textAlign: 'center' }}>
                                                            <b><span style={{ color: contaminantEvaluation.pathogen == 'High' ? 'rgb(224, 0, 0)' : (contaminantEvaluation.pathogen == 'Medium' ? 'rgb(255, 134, 3)' : (contaminantEvaluation.pathogen == 'Low' ? 'rgb(0, 188, 18)' : '')) }}>{contaminantEvaluation.pathogen}</span></b>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            {pathogenRows != undefined && pathogenRows.length > 0 && showsavingPathogen &&
                                                pathogenRows[0].value != '' && pathogenRows[1].value != '' && pathogenRows[2].value != '' &&
                                                pathogenRows[0].value != null && pathogenRows[1].value != null && pathogenRows[2].value != null &&
                                                (roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                                                <>
                                                    {savingPathogen ?
                                                        <Button style={{ float: "right" }} onClick={handleSavingPathogen}
                                                            color="success"
                                                            disabled
                                                        >
                                                            <Row>
                                                                <Col sm="8">
                                                                    <span>
                                                                        {' '}Saving
                                                                    </span>
                                                                </Col>
                                                                <Col sm="4">
                                                                    <Spinner size="sm">
                                                                        Saving...
                                                                    </Spinner>
                                                                </Col>
                                                            </Row>
                                                        </Button>
                                                        :
                                                        <Button style={{ float: "right" }} onClick={handleSavingPathogen} color="success" size="sm">
                                                            Save
                                                        </Button>
                                                    }
                                                </>

                                            }
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Collapse>
                        </Card>
                        
                    </Col>
                </Row>
                <Row xs="2">
                    <Col>
                        <Card className="my-4 card-header-outline" style={{ minHeight: "42vw", maxHeight: "100vw" }}>
                            <CardHeader className="" onClick={togglesPhosphorus}>
                                <Row>
                                    <Col sm="11">
                                        <h5>Phosphorus</h5>
                                    </Col>
                                    <Col sm="1" className="toggleoutline_lt">{isPhosphorusIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                                </Row>
                            </CardHeader>
                            <br />
                            <Collapse isOpen={isPhosphorusOpen}>
                                <CardBody>
                                    <Row>
                                        <Col>
                                            <table style={{ float: "right", marginTop: "-10px" }} className="table table-bordered table-hover" id="tab_logic">
                                                <thead>
                                                    <tr>
                                                        <th className="text-left"> </th>
                                                        <th className="text-left"> Phosphorus loss Risk to Freshwater  </th>
                                                        <th className="text-left"> Yes/No </th>
                                                    </tr>
                                                </thead>
                                                <tbody className="text-left">
                                                    {phosphorousRows != undefined &&
                                                        phosphorousRows.length > 0 &&
                                                        phosphorousRows.map((item, idx) => (
                                                            <tr id="addr0" key={idx}>
                                                                <td style={{ display: "none" }}>{phosphorousRows[idx].id}</td>
                                                                <td style={{ width: "10%" }}>
                                                                    {phosphorousRows[idx].srNo}
                                                                </td>
                                                                <td style={{ width: "80%" }}>
                                                                    {phosphorousRows[idx].description}
                                                                </td>
                                                                <td style={{ width: "10%" }}>
                                                                    <Input type="select" value={phosphorousRows[idx].value} onChange={(e) => handlePhosphorousValueChange(e, idx, phosphorousRows[idx].srNo)} name="value" id="value">
                                                                        <option key={uuid()} value=''></option>
                                                                        <option key={uuid()} value='Yes'>Yes</option>
                                                                        <option key={uuid()} value='No'>No</option>
                                                                    </Input>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    <tr id="addr0" key="phosphorousResult" style={{ backgroundColor: "rgba(82, 175, 181, 0.18)" }}>
                                                        <td style={{ width: "90%" }} colSpan="2">
                                                            <b>Risk Evaluation Guide</b>
                                                            <br />
                                                            • If you answered yes to any one of the above questions, then you have at least a medium risk of phosphorus contamination of freshwater.
                                                            <br />
                                                            • If you answered yes to more than one question, then you will likely have a high risk of phosphorus contamination of freshwater.
                                                        </td>
                                                        <td style={{ width: "10%", textAlign: 'center' }}>
                                                            <b><span style={{ color: contaminantEvaluation.phosphorous == 'High' ? 'rgb(224, 0, 0)' : (contaminantEvaluation.phosphorous == 'Medium' ? 'rgb(255, 134, 3)' : (contaminantEvaluation.phosphorous == 'Low' ? 'rgb(0, 188, 18)' : '')) }}>{contaminantEvaluation.phosphorous}</span></b>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            {phosphorousRows != undefined && phosphorousRows.length > 0 && showsavingPhosphorous &&
                                                phosphorousRows[0].value != '' && phosphorousRows[1].value != '' && phosphorousRows[2].value != '' && phosphorousRows[3].value != '' &&
                                                phosphorousRows[0].value != null && phosphorousRows[1].value != null && phosphorousRows[2].value != null && phosphorousRows[3].value != null &&
                                                phosphorousRows[4].value != '' && phosphorousRows[5].value != '' &&
                                                phosphorousRows[4].value != null && phosphorousRows[5].value != null &&
                                                (roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                                                <>
                                                    {savingPhosphorous ?
                                                        <Button style={{ float: "right" }} onClick={handleSavingPhosphorous}
                                                            color="success"
                                                            disabled
                                                        >
                                                            <Row>
                                                                <Col sm="8">
                                                                    <span>
                                                                        {' '}Saving
                                                                    </span>
                                                                </Col>
                                                                <Col sm="4">
                                                                    <Spinner size="sm">
                                                                        Saving...
                                                                    </Spinner>
                                                                </Col>
                                                            </Row>
                                                        </Button>
                                                        :
                                                        <Button style={{ float: "right" }} onClick={handleSavingPhosphorous} color="success" size="sm">
                                                            Save
                                                        </Button>
                                                    }
                                                </>

                                            }
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Collapse>
                        </Card>
                    </Col>
                    <Col>
                        <Card className="my-4 card-header-outline" style={{ minHeight: "42vw", maxHeight: "100vw" }}>
                            <CardHeader className="" onClick={toggleErosion}>
                                <Row>
                                    <Col sm="11">
                                        <h5>Erosion</h5>
                                    </Col>
                                    <Col sm="1" className="toggleoutline_lt">{isErosionIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                                </Row>
                            </CardHeader>
                            <br />
                            <Collapse isOpen={isErosionOpen}>
                                <CardBody>
                                    <Row>
                                        <Col>
                                            <table style={{ float: "right", marginTop: "-10px" }} className="table table-bordered table-hover" id="tab_logic">
                                                <thead>
                                                    <tr>
                                                        <th className="text-left"> </th>
                                                        <th className="text-left"> Sediment Contamination Risk to Freshwater (from erosion)  </th>
                                                        <th className="text-left"> Yes/No </th>
                                                    </tr>
                                                </thead>
                                                <tbody className="text-left">
                                                    {erosionRows != undefined &&
                                                        erosionRows.length > 0 &&
                                                        erosionRows.map((item, idx) => (
                                                            <tr id="addr0" key={idx}>
                                                                <td style={{ display: "none" }}>{erosionRows[idx].id}</td>
                                                                <td style={{ width: "10%" }}>
                                                                    {erosionRows[idx].srNo}
                                                                </td>
                                                                <td style={{ width: "80%" }}>
                                                                    {erosionRows[idx].description}
                                                                </td>
                                                                <td style={{ width: "10%" }}>
                                                                    <Input type="select" value={erosionRows[idx].value} onChange={(e) => handleErosionValueChange(e, idx, erosionRows[idx].srNo)} name="value" id="value">
                                                                        <option key={uuid()} value=''></option>
                                                                        <option key={uuid()} value='Yes'>Yes</option>
                                                                        <option key={uuid()} value='No'>No</option>
                                                                    </Input>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    <tr id="addr0" key="erosionResult" style={{ backgroundColor: "rgba(82, 175, 181, 0.18)" }}>
                                                        <td style={{ width: "90%" }} colSpan="2">
                                                            <b>Risk Evaluation Guide</b>
                                                            <br />
                                                            • If you answered Yes for questions 1, 2 or 3 then your overall risk is likely to be low.
                                                            <br />
                                                            • If you answered Yes 4, 5 or 6 then your overall risk is likely to be Medium.
                                                            <br />
                                                            • If you answered Yes to 7 or 8 then your overall risk is likely to be High.
                                                        </td>
                                                        <td style={{ width: "10%", textAlign: 'center' }}>
                                                            <b><span style={{ color: contaminantEvaluation.erosion == 'High' ? 'rgb(224, 0, 0)' : (contaminantEvaluation.erosion == 'Medium' ? 'rgb(255, 134, 3)' : (contaminantEvaluation.erosion == 'Low' ? 'rgb(0, 188, 18)' : '')) }}>{contaminantEvaluation.erosion}</span></b>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            {erosionRows != undefined && erosionRows.length > 0 && showsavingErosion &&
                                                erosionRows[0].value != '' && erosionRows[1].value != '' && erosionRows[2].value != '' && erosionRows[3].value != '' &&
                                                erosionRows[0].value != null && erosionRows[1].value != null && erosionRows[2].value != null && erosionRows[3].value != null &&
                                                erosionRows[4].value != '' && erosionRows[5].value != '' && erosionRows[6].value != '' && erosionRows[7].value != '' &&
                                                erosionRows[4].value != null && erosionRows[5].value != null && erosionRows[6].value != null && erosionRows[7].value != null &&
                                                (roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                                                <>
                                                    {savingErosion ?
                                                        <Button style={{ float: "right" }} onClick={handleSavingErosion}
                                                            color="success"
                                                            disabled
                                                        >
                                                            <Row>
                                                                <Col sm="8">
                                                                    <span>
                                                                        {' '}Saving
                                                                    </span>
                                                                </Col>
                                                                <Col sm="4">
                                                                    <Spinner size="sm">
                                                                        Saving...
                                                                    </Spinner>
                                                                </Col>
                                                            </Row>
                                                        </Button>
                                                        :
                                                        <Button style={{ float: "right" }} onClick={handleSavingErosion} color="success" size="sm">
                                                            Save
                                                        </Button>
                                                    }
                                                </>

                                            }
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Collapse>
                        </Card>
                    </Col>
                </Row>
            </>
            }
        </div>
    )
}

export default ContaminantEvaluation;